module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reviews_count":"리뷰","product_score":"평점"}}')
  delete Component.options._Ctor
}
